import { useCollectionsCompute } from "@/store/useCollectionsCompute";
import { computeTaskFold, NO_TASKS, type TaskFold, taskCollections } from "./tasks";

/**
 * The workspace's task fold, recomputed as tasks, pins and their acknowledgements land.
 *
 * {@link NO_TASKS} while `enabled` is false, so a workspace without tasks never walks the collections.
 *
 * @param workspaceId - The workspace whose tasks are folded.
 * @param now - The page's minute clock, which moves the lookback.
 * @param enabled - Whether the workspace's task surface is on.
 */
export function useTaskFold(workspaceId: string, now: number, enabled: boolean): TaskFold {
  return useCollectionsCompute(
    taskCollections,
    () => (enabled ? computeTaskFold(workspaceId, now) : NO_TASKS),
    [enabled, workspaceId, now],
    "Dispatch:tasks",
  );
}
